import { Stack, Chip } from "@mui/material";

const FormattedIdList = ({ idListMap, onDelete }) => {
  return (
    <Stack
      direction={"column"}
      spacing={2}
      border={"1px solid #e0e0e0"}
      p={2}
      maxHeight={"300px"}
      overflow={"auto"}
    >
      <Stack direction={"row"} flexWrap={"wrap"} spacing={1} rowGap={1}>
        {Array.from(idListMap.values()).map((id, index) => (
          <Chip
            key={index}
            label={`${id}`}
            onDelete={() => onDelete(id)}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default FormattedIdList;
